import { initInvestorStickyNavScroll } from '../investor-zone/investor-sticky-nav.js';

function initInstallerFaqList(list) {
    const items = list.querySelectorAll('.investor-radiator-heating__installer-faq-item');

    const closeItem = (item) => {
        const trigger = item.querySelector('.investor-radiator-heating__installer-faq-trigger');
        const panel = item.querySelector('.investor-radiator-heating__installer-faq-panel');

        item.classList.remove('is-open');
        trigger?.setAttribute('aria-expanded', 'false');

        if (!panel) return;

        if (panel.style.maxHeight === 'none' || panel.style.maxHeight === '') {
            panel.style.maxHeight = `${panel.scrollHeight}px`;
        }

        panel.getBoundingClientRect();
        panel.style.maxHeight = '0';
    };

    const openItem = (item) => {
        const trigger = item.querySelector('.investor-radiator-heating__installer-faq-trigger');
        const panel = item.querySelector('.investor-radiator-heating__installer-faq-panel');

        item.classList.add('is-open');
        trigger?.setAttribute('aria-expanded', 'true');

        if (panel) {
            panel.style.maxHeight = `${panel.scrollHeight}px`;
        }
    };

    items.forEach((item) => {
        const trigger = item.querySelector('.investor-radiator-heating__installer-faq-trigger');
        const panel = item.querySelector('.investor-radiator-heating__installer-faq-panel');

        if (!trigger || !panel) return;

        panel.addEventListener('transitionend', (event) => {
            if (event.propertyName !== 'max-height' || !item.classList.contains('is-open')) return;
            panel.style.maxHeight = 'none';
        });

        trigger.addEventListener('click', () => {
            const isOpen = item.classList.contains('is-open');

            items.forEach((other) => {
                if (other !== item) closeItem(other);
            });

            if (isOpen) {
                closeItem(item);
            } else {
                openItem(item);
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initInvestorStickyNavScroll(
        '.investor-radiator-heating__sticky-nav',
        'a[href^="#dla-"]',
    );

    const faqList = document.getElementById('investorRadiatorInstallerFaq');
    if (faqList) initInstallerFaqList(faqList);
});
